var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDownIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_796_97)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.2066 8.70326C12.2573 9.66326 11.3081 10.6233 10.3598 11.5853L10.1168 11.8323L9.87281 11.5873C8.69543 10.3963 7.51607 9.20626 6.33771 8.01726L5.05618 6.72426C4.91434 6.57926 4.77944 6.43926 4.63562 6.31026C4.37078 6.07226 4.02561 5.98426 3.71316 6.07626C3.39179 6.17026 3.14183 6.43326 3.04066 6.78326C2.93651 7.15226 3.03074 7.46526 3.34318 7.77926L8.74999 13.2263L8.74503 13.2313L10.1168 14.6143C10.9847 13.7333 11.8526 12.8533 12.7225 11.9763L15.0237 9.64526C15.0664 9.60326 15.1318 9.53926 15.2151 9.46926L15.5018 9.18126C15.9819 8.69726 16.4629 8.21226 16.943 7.72726C17.1364 7.52826 17.2416 7.28826 17.2416 7.03026C17.2416 6.91526 17.2217 6.79826 17.1811 6.67826C17.0472 6.27626 16.7625 6.04326 16.3519 6.00426C15.9124 5.96126 15.6198 6.26026 15.5087 6.37126L13.2066 8.70326Z",
    fill: "#565656"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_796_97"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownIcon);
export default __webpack_public_path__ + "static/media/downIcon.ee45dad0.svg";
export { ForwardRef as ReactComponent };